import { Link } from '../../../store/Link';
import { DetailPanelParams, FieldLabelMap } from '../../Compounds/DetailPanel/DetailPanel';

export const FIELD_LABEL_MAP: FieldLabelMap = {
  assetTsd: 'TSD',
  rpmSource: 'RPM Source',
  assetSalesAgent: 'Sales Agent',
  rpmAssignedAgency: 'RPM Agency Group',
  assetCustomer: 'Customer',
  rpmAccountCustomerName: 'RPM Customer'
};

export const linkSectionsInfo = (data: Link): DetailPanelParams[] => [
  {
    data,
    canEdit: [],
    fieldMap: FIELD_LABEL_MAP,
    order: ['assetTsd', 'rpmSource', 'assetSalesAgent', 'rpmAssignedAgency', 'assetCustomer', 'rpmAccountCustomerName'],
    links: [{ field: 'assetCustomer', link: `/customer/${data.assetCustomerId}`, external: false }]
  }
];
